import { useMutation, useQueryClient, type UseMutationResult } from "@tanstack/react-query";

import { useVidarioClient } from "../client";
import { type InviteUserInput, type InviteUserResult } from "../endpoints";

/** Admin-only: invite a recruiter or admin. Idempotent — re-sends the
 * setup link if the email already exists (the result carries an
 * `existing` flag so the caller can word the success toast accordingly). */
export function useInviteUser(): UseMutationResult<InviteUserResult, Error, InviteUserInput> {
  const client = useVidarioClient();
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (input) => client.inviteUser(input),
    onSuccess: (result) => {
      // Only refresh the user list when a new row was created — re-sends
      // don't mutate state. Mirrors useUsers's raw ["users"] queryKey.
      if (!result.existing) {
        qc.invalidateQueries({ queryKey: ["users"] });
      }
    },
  });
}
